import { useEffect } from 'react';

import SearchBarDateRangeInput from '@components/ui/search/SearchBarInput/SearchBarDateInput/SearchBarRangeDatePickerInput/SearchBarDateRangePickerInput';
import ResponsiveDateRangeSelect from '@components/views/flight/listing/SearchBar/DateSelect/ResponsiveDateRangeSelect';
import { getDateRangePickerPlaceholder } from '@components/views/flight/listing/SearchBar/DateSelect/utils';
import {
  DateType,
  getCurrentDate,
  getNMonthsLater,
  isInclusivelyAfterDay,
} from '@utils/dateUtil';
import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { useDevice } from '@contexts/device';

import { BookerSearchBarDateRangeHotelInputWrapper } from './style';

interface Props {
  setLocalStartDate: React.Dispatch<React.SetStateAction<DateType | null>>;
  setLocalEndDate: React.Dispatch<React.SetStateAction<DateType | null>>;
  localStartDate: DateType | null;
  localEndDate: DateType | null;
  dateChange: (dates?: {
    startDate?: DateType | null;
    endDate?: DateType | null;
  }) => void;
  isPreviousSearch?: boolean;
  isHoliday?: boolean;
}

const HotelBookerDatePicker = ({
  dateChange,
  setLocalEndDate,
  setLocalStartDate,
  localStartDate,
  localEndDate,
  isPreviousSearch,
  isHoliday,
}: Props) => {
  const setDates = ({
    startDate,
    endDate,
  }: {
    startDate: DateType | null;
    endDate: DateType | null;
  }) => {
    setLocalStartDate(startDate);
    setLocalEndDate(endDate);
    if (startDate && endDate) dateChange({ startDate, endDate });
  };
  const { isDesktop } = useDevice();

  useEffect(() => {
    if (!localStartDate) return;
    isInclusivelyAfterDay(localStartDate, getNMonthsLater(localStartDate, 1));
  }, [localStartDate]);
  return (
    <BookerSearchBarDateRangeHotelInputWrapper>
      {isDesktop ? (
        <SearchBarDateRangeInput
          label='Ne Kadar Kalacaksınız?'
          placeholder='Giriş - Çıkış Tarihleri'
          isHoliday={isHoliday}
          dateProps={{
            startDate: localStartDate,
            endDate: localEndDate,
            onDatesChange: setDates,

            isOutsideRange: (day) =>
              !isInclusivelyAfterDay(day, getCurrentDate()) ||
              (localStartDate
                ? !localEndDate
                  ? isInclusivelyAfterDay(
                      day,
                      getNMonthsLater(localStartDate, 1)
                    )
                  : false
                : false),
          }}
        />
      ) : (
        <LocationAnimationErrorBox hasError={false}>
          <ResponsiveDateRangeSelect
            startDate={localStartDate}
            endDate={localEndDate}
            onDatesChange={setDates}
            isHoliday={isHoliday}
            title='Gidiş-Dönüş Tarihiniz?'
            subTitle={getDateRangePickerPlaceholder(
              localStartDate,
              localEndDate
            )}
            monthsRange={1}
            placeholder='Gidiş - Dönüş Tarihleri'
            drawerTitle='Tarih Arama'
            arrowIcon={true}
            isPreviousHotelDatePicker={isPreviousSearch}
          />
        </LocationAnimationErrorBox>
      )}
    </BookerSearchBarDateRangeHotelInputWrapper>
  );
};
export default HotelBookerDatePicker;
